module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Teufen-8a901e1ba93b7ee2363633d1ad095503.png";